import React from 'react';
import axios from 'axios';
import Header from '../Header/Header';
import { url } from '../../utils/const';

class ChangePassword extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            password: '',
            newPassword: '',
            repeatedPassword: '',
            error: '',
            success: ''
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(e) {
        this.setState({ [e.target.name]: e.target.value });
    }

    buildAuthorizationHeaderValue(token) {
        if (!token) return '';

        // als token al "bearer xxx" of "Bearer xxx" bevat -> strip prefix
        var lower = token.toLowerCase();
        if (lower.indexOf('bearer ') === 0) {
            token = token.substring(7);
        }

        // jouw backend verwacht in elk geval "bearer " (lowercase) in je eerdere logs/screenshots
        return 'bearer ' + token;
    }

    handleSubmit(event) {
        event.preventDefault();

        const passwordChange = {
            currentPassword: this.state.password,
            newPassword: this.state.newPassword,
            repeatedNewPassword: this.state.repeatedPassword
        };

        const token = localStorage.getItem('jwtToken');
        const authValue = this.buildAuthorizationHeaderValue(token);

        if (!authValue) {
            this.setState({
                error: "Je bent niet (meer) ingelogd. Log opnieuw in en probeer opnieuw.",
                success: ''
            });
            return;
        }

        axios.post(
            url + '/api/v1/secure/change-password/',
            passwordChange,
        )
            .then(() => {
                this.setState({
                    success: "Het wachtwoord is succesvol gewijzigd",
                    error: '',
                    password: '',
                    newPassword: '',
                    repeatedPassword: ''
                });
            })
            .catch(error => {
                var msg = "Wachtwoord wijzigen mislukt.";

                if (error && error.response && error.response.data) {
                    var data = error.response.data;

                    if (typeof data === "string") {
                        msg = data;
                    } else if (data && data.message) {
                        msg = data.message;
                    } else if (data && data.error) {
                        msg = data.error;
                    } else {
                        try {
                            msg = JSON.stringify(data);
                        } catch (e) {
                            msg = "Wachtwoord wijzigen mislukt (onbekende fout).";
                        }
                    }
                } else if (error && error.message) {
                    msg = error.message;
                }

                this.setState({
                    error: msg,
                    success: '',
                    password: '',
                    newPassword: '',
                    repeatedPassword: ''
                });
            });
    }

    render() {
        return (
            <div>
                <Header location={this.props.location} />
                <main className="main-content m-t-xs responsive-form">
                    <div className="container">
                        <div className="card small-padding m-t-42">

                            {this.state.error ? (
                                <div className="message error">{this.state.error}</div>
                            ) : null}

                            {this.state.success ? (
                                <div className="message success">{this.state.success}</div>
                            ) : null}

                            <form method="post" onSubmit={this.handleSubmit}>
                                <div className="col-3 float-left same-height-52 p-xs">
                                    <label className="block">Huidige wachtwoord:</label>
                                    <input
                                        type="password"
                                        name="password"
                                        value={this.state.password}
                                        onChange={this.handleChange}
                                    />
                                </div>

                                <div className="col-3 float-left same-height-52 p-xs">
                                    <label className="block">Nieuw wachtwoord:</label>
                                    <input
                                        type="password"
                                        name="newPassword"
                                        value={this.state.newPassword}
                                        onChange={this.handleChange}
                                    />
                                </div>

                                <div className="col-3 float-left same-height-52 p-xs">
                                    <label className="block">Herhaal wachtwoord:</label>
                                    <input
                                        type="password"
                                        name="repeatedPassword"
                                        value={this.state.repeatedPassword}
                                        onChange={this.handleChange}
                                    />
                                </div>

                                <div className="col-3 float-left same-height-52 p-xs">
                                    <label className="block">&nbsp;</label>
                                    <button className="full-width btn btn-info" type="submit">
                                        Wijzigen
                                    </button>
                                </div>
                            </form>

                        </div>
                    </div>
                </main>
            </div>
        );
    }
}

export default ChangePassword;
